import type Employee from '@/stores/Employee'
import type { Events } from '@/utilities/GlobalEvents'

/** Body for Error modal message */
export interface ErrorModalMessage {
	/** Header title */
	header: string
	/** Error message */
	message: string
}

/** Error modal message queue */
export type ErrorModalMessageQueue = ErrorModalMessage[]

/** Body for Question modal message */
export interface QuestionModalMessage {
	/** Header title */
	header: string
	/** Question text */
	message: string
	/** OK button label */
	ok?: string
	/** Cancel button label */
	cancel?: string
	/** Optional event to emit when Ok button was pushed */
	emit?: keyof Events
	/** Optional data to emit with event when OK button was pushed */
	emitData?: unknown
	/** Optional event to emit when Cancel button was pushed */
	cancelledEmit?: keyof Events
	/** Optional data to emit with event when Cancel button was pushed */
	cancelledEmitData?: unknown
}

/** Question modal queue */
export type QuestionModalMessageQueue = QuestionModalMessage[]

/** Setting for Audio player */
export interface AudioPlayerSettings {
	/** Headline text */
	header: string
	/** Id of audio file to play */
	audioId: string
	/** Length of audio in seconds */
	length: number
	/** Name of the audio file */
	filename: string
	/** True if file as been marked as played (Voicemail audio files only) */
	markAsPlayed?: boolean
	/** True if this is a voicemail audio file */
	isVoicemail: boolean
	/** Position in playback, in seconds */
	progress: number
	/** True if audio has been loaded and is ready to play */
	hasBeenLoaded: boolean
	/** True if audio is playing */
	isPlaying: boolean
	/** True if audio file is currently loading */
	isLoading: boolean
}

/** States for the login dialog */
export enum LoginDialogMode {
	USERNAME_PASSWORD = 'USERNAME_PASSWORD',
	SMS_ENTRY = 'SMS_ENTRY',
	AUTHENTICATOR_ENTRY = 'AUTHENTICATOR_ENTRY',
	AUTHENTICATOR_SETUP = 'AUTHENTICATOR_SETUP',
	PASSWORD_RESET = 'PASSWORD_RESET',
	PASSWORD_RESET_EMAIL_COMPLETED = 'PASSWORD_RESET_EMAIL_COMPLETED',
	PASSWORD_RESET_COMPLETED = 'PASSWORD_RESET_COMPLETED',
	PASSWORD_RESET_SMS_COMPLETED = 'PASSWORD_RESET_SMS_COMPLETED'
}

/** Inteface for Draggable @change event in ExtensionsPanel.vue */
export interface DraggeableChangeEventExtensions {
	added?: {
		element: Employee
		newIndex: number
	}
	removed?: {
		element: Employee
		oldIndex: number
	}
	moved?: {
		element: Employee
		oldIndex: number
		newIndex: number
	}
}
